var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#351C15",
    fillRule: "nonzero",
    cx: 256,
    cy: 256,
    r: 256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.3 109.1S168.5 78 260.8 78s145.4 31.1 145.4 31.1v186.3s-.6 48.6-33.4 77.4c-32.8 28.9-116.1 61.7-116.1 61.7s-83-35.6-106.2-53.2c-23.2-17.5-44.1-55.8-44.1-85.9-.1-30.1-.1-186.3-.1-186.3z",
    fill: "#FFB500",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.7 183.2S176.6 130 250.9 117c74.3-13 143.4-4.5 143.4-4.5v186.7s-4.8 47.5-29 65.1c-24.2 17.5-87.3 53.2-108.7 57.7 0 0-94.4-44.7-101.7-52.6-7.4-7.9-36.2-30-36.2-71.3V183.2z",
    fill: "#351C15",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358 295.3c-.2-8-4.6-12.4-15.7-19-20.9-12.4-24.7-22.7-24.8-36.4-.1-20.8 17.4-32.8 33.9-33.1 13.8-.3 23 5.1 27.4 8.6v22.1c-5.1-5.5-13.5-10.5-22.3-10.6-7.1-.1-14.6 3-14.8 12.1-.2 9.3 7.3 13 16.6 18.6 20.9 12.6 24.7 23.8 24.3 38.6-.5 16.2-11.3 34.1-36.2 34.4-10 .1-19.9-3-27.9-7.7 0-7.9.1-15.7.1-23.7 6.5 5.9 16.2 10.3 24.3 10.3 9.2.1 15.3-5.3 15.1-14.2zM178.7 309c5.1 0 9.3-1.1 12-3-.1-32.2-.1-64.6.1-96.7 8.5-.1 16.9-.1 25.5-.2-.1 37-.1 74.5 0 111.5-9.8 6.6-22.9 10.2-38.3 10-25-.3-37.2-14.1-37.3-41v-79.9c8.2-.1 16.6-.2 24.9-.3-.1 27-.2 54.3-.1 81.4 0 7.4 1.7 18.1 13.2 18.2z",
    fill: "#FFB500",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.3 382.6v-53.4c2.6.8 6.3 1.4 11.6 1.4 28.5 0 45-25.7 45-63.3 0-37.5-16.9-60.8-47.6-60.8-14 0-25.3 3.1-34.6 9.2-.1 55.7-.1 112.4.2 166.9h25.4z",
    fill: "#FFB500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.3 229c2.1-1 5.7-1.8 9.1-1.8 15 0 21.2 11.9 21.2 40.8 0 28.2-7.1 41.8-22 41.8-3.5 0-6.5-.9-8.4-1.6 0-26.4.1-52.9.1-79.2z",
    fill: "#351C15",
    fillRule: "nonzero"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUps);
export default __webpack_public_path__ + "static/media/ups.681a45f305c2ebb39b4d59bfba915462.svg";
export { ForwardRef as ReactComponent };